import { render, staticRenderFns } from "./AiSuggestionReviewBar.vue?vue&type=template&id=652c90f0&scoped=true"
import script from "./AiSuggestionReviewBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AiSuggestionReviewBar.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AiSuggestionReviewBar.vue?vue&type=style&index=0&id=652c90f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c90f0",
  null
  
)

export default component.exports